import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/ContecLogo.png'
import _imports_1 from '@/assets/images/SideLogo.png'


const _withScopeId = n => (_pushScopeId("data-v-7673340d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "login_panel"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: "Contec_Logo"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "side_logo",
  src: _imports_1,
  alt: "side logo"
}, null, -1))

import { storeToRefs } from 'pinia';

import LoginBox from '@/components/common/LoginBox.vue';
import IconButtons from '@/components/desktop/IconButtons.vue';
import useCommonStore from '@/store/storeCommon';
import useMemberStore from '@/store/storeMember';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPanel',
  setup(__props) {

const { isImageMode } = storeToRefs(useCommonStore());
const { disabledQualification, showPanel } = useCommonStore();
const { accessedMemberInfo } = useMemberStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "slide-fade" }, {
    default: _withCtx(() => [
      (!_unref(accessedMemberInfo).name && !_unref(isImageMode))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_unref(showPanel).isLeftPanel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["login_box_wrap", {'opacity': _unref(disabledQualification)()}])
                  }, [
                    _hoisted_2,
                    _hoisted_3,
                    _createVNode(LoginBox),
                    _createVNode(IconButtons)
                  ], 2)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})